import type { IRange } from "app/pages/sales-intelligence/types/range";

import { MAX_RANGE_SELECT_VALUE, INFINITY_CHARACTER_CODE, MIN_RANGE_SELECT_VALUE } from "../constants";

export const getFormattedRangeValue = (
    formatter: (value: number) => string,
    options: readonly number[],
    range?: Partial<IRange<number>>,
): string => {
    if (range) {
        const [from, to] = [range.from ?? MIN_RANGE_SELECT_VALUE, range.to ?? options.at(-1) ?? MAX_RANGE_SELECT_VALUE];
        const formaterWithInfinity = (value: number) =>
            value === MAX_RANGE_SELECT_VALUE ? String.fromCharCode(INFINITY_CHARACTER_CODE) : formatter(value);
        return `${formaterWithInfinity(from)} - ${formaterWithInfinity(to)}`;
    }

    return "";
};

export const getFormattedValue = (formatter: (value: number) => string, value: number): string => {
    if (value === MAX_RANGE_SELECT_VALUE) {
        return String.fromCharCode(INFINITY_CHARACTER_CODE);
    }
    return formatter(value);
};
